exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".translations-list-component .focus-editable {\n  line-height: 1.8;\n}\n.translations-list-component .focus-editable:not(:focus) {\n  border-color: transparent;\n}\n.translations-list-component .fixed-50 {\n  width: 50%;\n}\n.translations-list-component th.bt-0 {\n  border-top: none !important;\n}\n.translations-list-component .translation-edited, .translations-list-component .translation-edited:focus {\n  background-color: #fdf9ee;\n}", ""]);

// exports
